// Every service required for broker display
import axios from 'axiosConfig';
// import axiosInstance from './axiosConfig';

const getBrokerSettings = async () => {
  const {data} = await axios.get('api/brokersetting/');
  console.log('brokerSetting', data);
  return data;
};

const brokerSettingsService = {
  getBrokerSettings,
};

export default brokerSettingsService;
